import { REDUX_SORT_ORDER } from '../../constants/should-sort'
import { REDUX_DOMAIN_LIST_SECTION_DATE_KEYS } from '../../constants/key'

export default function getSortOrderReduxUtil ({ domainListPath = '' }) {
  if (REDUX_DOMAIN_LIST_SECTION_DATE_KEYS.find(key => domainListPath.includes(key))) {
    return REDUX_SORT_ORDER.ASC
  }
}
